export const SectionHeading = ({ title, subtitle, centered = true, light = false }) => {
  return (
    <div className={`mb-12 ${centered ? "text-center" : ""}`}>
      <h2
        className={`font-heading text-3xl sm:text-4xl lg:text-5xl font-bold uppercase tracking-tight mb-4 ${
          light ? "text-charcoal" : "text-white"
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p className={`text-base md:text-lg max-w-2xl ${centered ? "mx-auto" : ""} ${light ? "text-zinc-600" : "text-zinc-400"}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
};
